var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    fillRule: "evenodd",
    d: "M19.753 7.615a.84.84 0 0 1 0 1.191L8.806 19.753a.842.842 0 0 1-.595.247H4.842A.842.842 0 0 1 4 19.158v-3.369c0-.223.089-.437.247-.595L15.194 4.247a.839.839 0 0 1 1.19 0c.33.329.33.862 0 1.19l-10.7 10.701v2.178h2.178l10.7-10.7a.84.84 0 0 1 1.191 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    fillRule: "evenodd",
    d: "M15.194 4.247a.839.839 0 0 1 1.19 0l3.37 3.368a.843.843 0 0 1-1.192 1.191l-3.368-3.368a.842.842 0 0 1 0-1.191zm.842 7.085-3.368-3.368 1.19-1.191 3.369 3.368-1.19 1.191z",
    clipRule: "evenodd"
  })));
};
export default SvgEdit;